export enum CALC_TYPES {
  PROJECTION = 0,
  ANGLE = 6,
  TENSION = 7,
  HTENSION = 8,
  VTENSION = 9,
}
